import React from 'react';


export const LandingSpecializations = ({ navigate, t }) => (
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="mx-auto max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl font-bold text-gray-900 mb-4">
              {t('landing.popularSpecializations')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('landing.indiaExpertise')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { nameKey: 'landing.specializations.cardiology', icon: '❤️', count: '450+' },
              { nameKey: 'landing.specializations.orthopedics', icon: '🦴', count: '380+' },
              { nameKey: 'landing.specializations.oncology', icon: '🎗️', count: '290+' },
              { nameKey: 'landing.specializations.fertility', icon: '👶', count: '220+' },
              { nameKey: 'landing.specializations.dental', icon: '🦷', count: '510+' },
              { nameKey: 'landing.specializations.cosmetic', icon: '✨', count: '180+' }
            ].map((spec, index) => (
              <div
                key={index}
                onClick={() => navigate('/treatments')}
                className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-6 border-2 border-orange-100 hover:border-orange-300 hover:shadow-lg transition-all text-center cursor-pointer"
                data-testid={`specialization-card-${index}`}
              >
                <div className="text-4xl mb-3">{spec.icon}</div>
                <h4 className="font-semibold text-gray-900 mb-1">{t(spec.nameKey)}</h4>
                <p className="text-sm text-gray-600">{spec.count} {t('nav.doctors')}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
);
